import RevolucciProvider from '@encodium/rp-ui/contexts/revoluccui-theme';

import { IslandPortalThemeLayer } from './island-portal-theme-layer.jsx';
import { IslandRootProvider } from './island-root-context.jsx';

/**
 * Shared island UI providers: island root context, Revolucci theme, and MUI portal defaults.
 * @param {{
 *   children: import('react').ReactNode,
 *   islandRootElement?: Element | null,
 *   locale?: string,
 * }} props
 */
export function IslandUiProvider({ children, islandRootElement = null, locale }) {
	const revolucciProviderProps = locale === undefined ? {} : { locale };

	return (
		<IslandRootProvider islandRootElement={islandRootElement}>
			<RevolucciProvider {...revolucciProviderProps}>
				<IslandPortalThemeLayer islandRootElement={islandRootElement}>
					{children}
				</IslandPortalThemeLayer>
			</RevolucciProvider>
		</IslandRootProvider>
	);
}
